import React, { useEffect, useState, useRef } from 'react';
import { SeatsioSeatingChart } from "@seatsio/seatsio-react";
import { DeleteOutlined } from '@ant-design/icons';
import * as moment from "moment-timezone";
import { useForm, useWatch } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import SimpleReactValidator from "simple-react-validator";
import { getEventDetailsById, getEventPaymentDetails } from "../../api";
import {
    Button,
    H1Text,
    Spinner,
    Input, LabelText, SpanText, Text, SelectBox
} from "../../design";
import { isValidPhoneNumber, formatNumber } from 'libphonenumber-js';
import { format } from "../../utils/timer";
import {
    SpError,
    SpText,
} from '../../widgetDesign';
import currencyFormatter from "../../utils/currencyformatter";
import { inputHeight, normalTextFontSize, smallTextFontSize } from "../../utils/reseponsive";
import { AmountDivideByHundred } from "../../helper";
import { PAGES, COUNTRY_PHONE_CODE } from '../../appconstants';
import InputQuantity from "./components/InputQuantity";
import bookWithButton from '../../assets/imgs/Book With_Button_Rounded.svg';

type Props = {
    history: {
        push: Function,
    },
}

export const { format: formatPrice } = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    currencyDisplay: 'narrowSymbol'
});


const Seats = (props: Props) => {

    const { match: { params: { eventLinkId } }, location: { pathname, search } } = props;
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [seatInfo, setSeatInfo] = useState();
    const [maxSelectedObjects, setMaxSelectedObjects] = useState();
    const [count, setCount] = useState(0);
    const [timer, setTimer] = useState(true);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const selectedData = localStorage.getItem('seatsData');
    const [publicKey, setPublicKey] = useState();
    const [eventKey, setEventKey] = useState();
    const isBack = localStorage.getItem('checkoutPage');
    const [tooltipData, setTooltipData] = useState();
    const [nonEventsSeats, setNonEventSeats] = useState([]);
    const [numAndAlpha, setNumAndAlpha] = useState([]);
    const [defaultCategory, setDefaultCategorty] = useState({});
    const [subTotal, setSubTotal] = useState(null);
    const [countryCode, setCountryCode] = useState();
    const [isDataValid, setIsDataValid] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [alphaNum, setAlphaNum] = useState('');
    const [, forceUpdate] = useState();
    const [mobileView, setMobileView] = useState(false);
    const [singleLineText, setSingleLineText] = useState([]);
    const [inputEmail, setInputEmail] = useState([]);
    const [inputPhone, setInputPhone] = useState([]);
    const [promotionalCode, setPromotionalCode] = useState([]);
    const [discountAmount, setDiscountAmount] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [showPromoCode, setShowPromoCode] = useState(false);
    const [promoError, setPromoError] = useState(false);


    useEffect(() => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 480) {
            setMobileView(true);
        }
    }, []);

    const {
        control,
        handleSubmit,
        errors,
        setValue,
        getValues,
    } = useForm();

    let seatsData = [];
    let totalAmount = 0;

    useEffect(() => {
        if (isBack) {
            setSelectedSeats([]);
            localStorage.removeItem('seatsData');
            localStorage.removeItem('checkoutPage');
        }
    }, [isBack]);

    useEffect(() => {
        const litItems = [...nonEventsSeats];
        for (let k = 0; k < litItems.length; k += 1) {
            if (litItems[k].name && litItems[k].email && litItems[k].phone) {
                setIsDataValid(false);
            }
        }
    }, [nonEventsSeats])

    useEffect(() => {
        if (selectedData && !isBack) {
            seatsData = JSON.parse(selectedData);
            setSelectedSeats(seatsData);
        }
    }, [selectedData]);

    useEffect(() => {
        getEventDataWithoutSearchValue();
    }, [eventLinkId, search]);

    const getEventDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, null);
            if (value && value.seatPageMeta) {
                setEventDetails(value.seatPageMeta);
                setCountryCode(`+${getCountryCallingCode(value.account.country.alpha2)}`);
            }

        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const removeGetSplitUp = async () => {
      let litItems;
      const finalData = [];
      if (eventDetails?.seatData) {
        litItems = [...selectedSeats];
        for (let i = 0; i < litItems.length; i += 1) {
          const testObj = {};
          testObj.seatPageMetaTicketGid = litItems[i].selectedTicketType;
          testObj.type = 'TICKET';
          testObj.value = 1;
          testObj.seat = litItems[i].id
          finalData.push(testObj);
      }
      } else {
        litItems = [...nonEventsSeats];
        for (let i = 0; i < litItems.length; i += 1) {
          for (let j = 0; j < litItems[i].selectedQnty; j += 1) {
              const testObj = {};
              testObj.seatPageMetaTicketGid = litItems[i].gid;
              testObj.type = litItems[i].type;
              testObj.value = 1;
              finalData.push(testObj);
          }
      }
      }
      const litItemsPromos = [...promotionalCode];
        for (let i = 0; i < litItemsPromos.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsPromos[i].gid;
            testObj.type = 'PROMOTIONAL_CODES';
            testObj.value = '';
            finalData.push(testObj);
            litItemsPromos[i].promotionalCode = '';
        }
        setPromotionalCode(litItemsPromos);
      try {
        const value = await getEventPaymentDetails(finalData, eventDetails?.gid);
        if (value) {
          setDiscountAmount(value?.discountedAmount);
          setSubTotal(value?.subTotal);
          setTotalPayable(value?.totalPayable);
        }
      } catch(e) {
        console.error(e);
      }
    }

    const getSplitUp = async () => {
      setPromoError(false);
      let litItems;
      const finalData = [];
      if (eventDetails?.seatData) {
        // litItems = [...selectedSeats];
        litItems = JSON.parse(localStorage.getItem('seatsData'));
        for (let i = 0; i < litItems.length; i += 1) {
          const testObj = {};
          testObj.seatPageMetaTicketGid = litItems[i].selectedTicketType;
          testObj.type = 'TICKET';
          testObj.value = 1;
          testObj.seat = litItems[i].id
          finalData.push(testObj);
      }
      } else {
        litItems = [...nonEventsSeats];
        for (let i = 0; i < litItems.length; i += 1) {
          for (let j = 0; j < litItems[i].selectedQnty; j += 1) {
              const testObj = {};
              testObj.seatPageMetaTicketGid = litItems[i].gid;
              testObj.type = litItems[i].type;
              testObj.value = 1;
              finalData.push(testObj);
          }
      }
      }       
        const litItemsPromos = [...promotionalCode];
        for (let i = 0; i < litItemsPromos.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsPromos[i].gid;
            testObj.type = 'PROMOTIONAL_CODES';
            testObj.value = litItemsPromos[i].promotionalCode;
            finalData.push(testObj);
        }
      try {
        const value = await getEventPaymentDetails(finalData, eventDetails?.gid);
        if (value) {
          setDiscountAmount(value?.discountedAmount);
          setSubTotal(value?.subTotal);
          setTotalPayable(value?.totalPayable);
          setPromoError(false);
        }
      } catch(e) {
        console.error(e);
        setPromoError(true);
        const litItemsPromos = [...promotionalCode];
        for (let i = 0; i < litItemsPromos.length; i += 1) {
          litItemsPromos[i].promotionalCode = '';
        }
        setPromotionalCode(litItemsPromos);
      }
    }

    useEffect(() => {
        if (eventDetails && eventDetails.seatData) {
            const listOfTickets = eventDetails.seatPageMetaTickets;
            const encodeQuery = atob(eventDetails.seatData);
            const parseData = JSON.parse(encodeQuery);
            const publicId = atob(eventDetails.seatPublicKey);
            const eventId = atob(eventDetails.seatEventId);
            setPublicKey(publicId);
            setEventKey(eventId);
            setSeatInfo(parseData.pricingData);
            setTooltipData(parseData.tooltipData);
            setMaxSelectedObjects(parseData.maxSelectedObjects);
            const promoList = listOfTickets.filter((item) => item.type === 'PROMOTIONAL_CODES');
            setPromotionalCode([...promoList]);
        } else if (eventDetails && !eventDetails.seatData) {
            const listOfTickets = eventDetails.seatPageMetaTickets;
            const ticketList = listOfTickets.filter((item) => item.type === 'PRICE_AMOUNT_STOCK_BASED');
            const numAlpha = listOfTickets.filter((item) => item.type === 'INPUT_ALPHA_NUMERIC');
            const nameList = listOfTickets.filter((item) => item.type === 'INPUT_SINGLE_LINE_TEXT');
            const emailList = listOfTickets.filter((item) => item.type === 'INPUT_EMAIL');
            const phoneList = listOfTickets.filter((item) => item.type === 'INPUT_PHONE');
            const promoList = listOfTickets.filter((item) => item.type === 'PROMOTIONAL_CODES');
            for (let i = 0; i < ticketList.length; i += 1) {
                ticketList[i].selectedQnty = null;
                ticketList[i].name = '';
                ticketList[i].email = '';
                ticketList[i].phone = '';
                ticketList[i].tempAmount = ticketList[i].quantityMinLimit * ticketList[i].price;
            }
            if (ticketList && ticketList.length !== 0) {
                setDefaultCategorty(ticketList[0]);
            }
            let amount = 0;
            for (let j = 0; j < ticketList.length; j += 1) {
                amount += ticketList[j].tempAmount;
            }
            setTotalPayable(amount);
            setSubTotal(amount);
            setNumAndAlpha([...numAlpha]);
            setNonEventSeats([...ticketList]);
            setSingleLineText([...nameList]);
            setInputEmail([...emailList]);
            setInputPhone([...phoneList]);
            setPromotionalCode([...promoList]);
        }
    }, [eventDetails]);

    useEffect(() => {
        if (!timer) {
            setTimeout(() => {
                const newCount = count - 1;
                setCount(newCount >= 0 ? newCount : 0);
                if (newCount <= 0) {
                    props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
                }
            }, 1000);
        }
    }, [count]);

    useEffect(() => {
        if (timer) {
            const seconds = 600;
            if (timer) {
                setCount(Math.trunc(seconds));
                setTimer(false);
            }
        }
    }, []);

    const getOperatingTime = (time) => {
        if (time !== 0) {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            let min;
            if (minutes < 10) {
                min = `0${minutes}`;
            } else if (minutes >= 10) {
                min = minutes;
            }
            if (hours > 12) {
                const hr = hours - 12;
                return `${hr}:${min} PM`;
            }
            if (hours === 0) {
                return `${12}:${min} AM`;
            }
            return `${hours}:${min} AM`;
        }
        return '12:00 AM';
    };

    const onObjectSelected = (item) => {
        const seatsList = [...seatsData];
        const selectedGid = item.selectedTicketType;
        const price = item.category.pricing && item.category.pricing.ticketTypes.filter((data) => data.ticketType === selectedGid);
        item.seatPrice = price && price[0].price;
        seatsList.push(item);
        setSelectedSeats(seatsList);
        seatsData = seatsList;
        localStorage.setItem('seatsData', JSON.stringify(seatsData));
        getSplitUp();
    };

    const onObjectDeselected = (item, price) => {
        const seatPriceGid = price && price.ticketType;
        const seatsList = [...seatsData];
        const seatId = item.id;
        if (!item.selected) {
            const seatsList2 = seatsList.filter((data) => data.id !== seatId);
            setSelectedSeats(seatsList2);
            seatsData = seatsList2;
            localStorage.setItem('seatsData', JSON.stringify(seatsData));
        } else if (item.selected && seatPriceGid) {
            const seatList1 = seatsList.filter((data) => data.id === seatId && data.selectedTicketType === seatPriceGid);
            const seatsList2 = seatsList.filter((data) => data.id === seatId && data.selectedTicketType !== seatPriceGid);
            const seatsList3 = seatsList.filter((data) => data.id !== seatId);
            console.log(seatList1.splice(-1));
            const seatFilterd = seatList1.slice(-1);
            setSelectedSeats([...seatList1, ...seatsList2, ...seatsList3]);
            seatsData = [...seatList1, ...seatsList2, ...seatsList3];
            localStorage.setItem('seatsData', JSON.stringify(seatsData));
        }
        getSplitUp();

    };

    const holdToken = (item) => {
        console.log(item, 'HOLD');
    };

    const subTotalGet = (list) => {
        totalAmount = list.reduce((n, { seatPrice }) => n + seatPrice, 0);
        return totalAmount;
    }

    const getSubToatal = (list) => {
        totalAmount = list.reduce((n, { seatPrice }) => n + seatPrice, 0);
        return (currencyFormatter((list.reduce((n, { seatPrice }) => n + seatPrice, 0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name))
    };

    const payTickets = () => {      
      const finalData = JSON.parse(selectedData);
      const litItemsPromos = [...promotionalCode];
        for (let i = 0; i < litItemsPromos.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsPromos[i].gid;
            testObj.type = 'PROMOTIONAL_CODES';
            testObj.value = litItemsPromos[i].promotionalCode;
            finalData.push(testObj);
        }
        localStorage.setItem('seatsData', JSON.stringify(finalData));
        props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}/pay`);
    };

    const tooltipFormat = (obj) => {
        const keyId = obj.category.key;
        const tooltipLabel = tooltipData && tooltipData.filter((data) => data.category.id === keyId);
        if (tooltipLabel && tooltipLabel.length !== 0) {
            return "" + tooltipLabel[0].category.tooltip;
        }
        return "";
    };

    const callCombo = (data, id) => {
        const litItems = [...nonEventsSeats];
        const index = litItems.findIndex(item => item.gid === id);
        litItems[index].selectedQnty = data;
        litItems[index].tempAmount = data * litItems[index].price;
        // for (let i = 0; i < litItems.length; i += 1) {
        //     if (litItems[i].gid === defaultCategory.gid) {
        //         litItems[i].selectedQnty = data;
        //         litItems[i].tempAmount = data * litItems[i].price;
        //     }
        // }
        let amount = 0;
        for (let j = 0; j < litItems.length; j += 1) {
            amount += litItems[j].tempAmount;
        }
        setTotalPayable(amount);
        setSubTotal(amount);
        setNonEventSeats(litItems);
    };

    const simpleValidator = useRef(new SimpleReactValidator({
        validators: {
            phoneNumValidation: {
                message: 'The phone number is invalid',
                rule: (val, param) => (isValidPhoneNumber(param[0])),
            },
            checkLowerCase: {
                message: 'Email address must not contain uppercase letters.',
                rule: (val) => val === val.toLowerCase(),
            },
        },
    }));

    const onCountryCodeChange = (e) => {
        setCountryCode(e.target.value);
    };

    const getEmailGid = (type) => {
        const listOfTickets = eventDetails.seatPageMetaTickets;
        const ticketList = listOfTickets.filter((item) => item.type === 'PRICE_AMOUNT_STOCK_BASED');
        const emailList = listOfTickets.filter((item) => item.type === 'INPUT_EMAIL');
        const phoneList = listOfTickets.filter((item) => item.type === 'INPUT_PHONE');
        const nameList = listOfTickets.filter((item) => item.type === 'INPUT_SINGLE_LINE_TEXT');
        const alphaNumList = listOfTickets.filter((item) => item.type === 'INPUT_ALPHA_NUMERIC');
        const litItems = [...ticketList, ...emailList, ...phoneList, ...nameList, ...alphaNumList];
        const tempItem = litItems.filter((item) => item.type === type);
        return tempItem && tempItem.length !== 0 ? tempItem[0].gid : null;
    }

    useEffect(() => {
        const litItems = [...nonEventsSeats];
        const finalItems = litItems.filter((item) => item.selectedQnty);
        if (finalItems && finalItems.length !== 0) {
            setIsDataValid(false);
        }
    }, [nonEventsSeats]);

    const validateFinalData = () => {
        const litItems = [...nonEventsSeats];
        const finalItems = litItems.filter((item) => item.selectedQnty);
        if (finalItems && finalItems.length !== 0) {
            setIsDataValid(false);
        }
    };

    const bookTickets = (event) => {
        event.preventDefault();
        const litItems = [...nonEventsSeats];
        const finalItems = litItems.filter((item) => item.selectedQnty);
        const formValid = simpleValidator.current.allValid();
        if (!formValid || (finalItems && finalItems.length === 0)) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
            setIsDataValid(true);
            validateFinalData();
            return;
        }
        const finalData = [];
        for (let i = 0; i < litItems.length; i += 1) {
            for (let j = 0; j < litItems[i].selectedQnty; j += 1) {
                const testObj = {};
                testObj.seatPageMetaTicketGid = litItems[i].gid;
                testObj.type = litItems[i].type;
                testObj.value = 1;
                finalData.push(testObj);
            }
        }
        // const emailObj = {
        //     seatPageMetaTicketGid: getEmailGid('INPUT_EMAIL'),
        //     type: 'INPUT_EMAIL',
        //     value: email,
        // };
        // finalData.push(emailObj);
        // const phoneObj = {
        //     seatPageMetaTicketGid: getEmailGid('INPUT_PHONE'),
        //     type: 'INPUT_PHONE',
        //     value: `${countryCode}${phone}`,
        // };
        // finalData.push(phoneObj);

        const litItemsPhone = [...inputPhone];
        for (let i = 0; i < litItemsPhone.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsPhone[i].gid;
            testObj.type = 'INPUT_PHONE';
            testObj.value = `${countryCode}${litItemsPhone[i].phone}`;
            finalData.push(testObj);
        }

        const litItemsEmail = [...inputEmail];
        for (let i = 0; i < litItemsEmail.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsEmail[i].gid;
            testObj.type = 'INPUT_EMAIL';
            testObj.value = litItemsEmail[i].email
            finalData.push(testObj);
        }
        const litItemsText = [...singleLineText];
        for (let i = 0; i < litItemsText.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsText[i].gid;
            testObj.type = 'INPUT_SINGLE_LINE_TEXT';
            testObj.value = litItemsText[i].value;
            finalData.push(testObj);
        }
        const litItemsAlpha = [...numAndAlpha];
        for (let i = 0; i < litItemsAlpha.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsAlpha[i].gid;
            testObj.type = 'INPUT_ALPHA_NUMERIC';
            testObj.value = litItemsAlpha[i].alphaNum
            finalData.push(testObj);
        }
        const litItemsPromos = [...promotionalCode];
        for (let i = 0; i < litItemsPromos.length; i += 1) {
            const testObj = {};
            testObj.seatPageMetaTicketGid = litItemsPromos[i].gid;
            testObj.type = 'PROMOTIONAL_CODES';
            testObj.value = litItemsPromos[i].promotionalCode;
            finalData.push(testObj);
        }
        localStorage.setItem('seatsData', JSON.stringify(finalData));
        props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}/pay`);
    };

    // const getText = (clr) => {
    //     if (clr === '#0AAC37;') {
    //         return 'Seats Available';
    //     }
    //     if (clr === '#E98612;') {
    //         return 'Hurry! Fast Filling';
    //     }
    //     if (clr === '#FF1515;') {
    //         return 'Few Seats Available';
    //     }
    // }

    // const getColorCode = (clr) => {
    //     if (clr === '#0AAC37;') {
    //         return '#0AAC37';
    //     }
    //     if (clr === '#E98612;') {
    //         return '#E98612';
    //     }
    //     if (clr === '#FF1515;') {
    //         return '#FF1515';
    //     }
    // }

    return (
        <div className='ml-4 mr-4'>

            {
                eventDetails && eventDetails.seatEventId ? (
                    <div>
                        <div
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >

                            <div
                                className="mt-4 mb-4"
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <p style={{ fontSize: '24px', fontWeight: '700' }}>{eventDetails && eventDetails.title} @ {eventDetails && eventDetails.venueAddress}</p>
                            </div>
                            <div
                                className="mt-4 mb-4"
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                {
                                    eventDetails && eventDetails.eventEndTime ? (
                                        <p style={{ fontSize: '18px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)} - {getOperatingTime(eventDetails && eventDetails.eventEndTime)}, Time Left: {format(count)}</p>
                                    ) : (
                                        <p style={{ fontSize: '18px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)}, Time Left: {format(count)}</p>
                                    )
                                }
                            </div>
                            <SeatsioSeatingChart
                                workspaceKey={publicKey}
                                pricing={seatInfo}
                                priceFormatter={(price) => formatPrice(price)}
                                maxSelectedObjects={maxSelectedObjects}
                                openDraftDrawing="true"
                                event={eventKey}
                                region="na"
                                onObjectSelected={onObjectSelected}
                                onObjectDeselected={(item, price) => onObjectDeselected(item, price)}
                                holdOnSelect={false}
                                tooltipInfo={(object) => tooltipFormat(object)}

                            // language="pt"
                            />
                        </div>
                        <div
                            style={{
                                justifyContent: 'start',
                                textAlign: 'center'
                            }}
                            className="pt-4"
                        >
                            <div>
                                <div
                                    className='pt-4'
                                    style={{
                                        justifyContent: 'start',
                                    }}
                                >
                                    <p style={{ fontSize: '20px', fontWeight: '600' }}>Order Summary</p>
                                </div>
                                {
                                    selectedSeats && selectedSeats.length !== 0 && (
                                        <>
                                            {
                                                selectedSeats.map((item, index) => (
                                                    <div
                                                        className='mt-4'
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'start',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: '50%',
                                                                justifyContent: 'start',
                                                            }}
                                                        >
                                                            {
                                                                item.numSelected ?
                                                                    <p style={{ fontSize: '18px', fontWeight: '600' }}>{item.seatId} - {item.numSelected}</p>
                                                                    :
                                                                    <p style={{ fontSize: '18px', fontWeight: '600' }}>{item.seatId}</p>
                                                            }
                                                        </div>
                                                        <div
                                                            style={{
                                                                width: '50%',
                                                                justifyContent: 'start',
                                                            }}
                                                        >
                                                            <p style={{ fontSize: '16px' }}>{currencyFormatter((item.seatPrice), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}</p>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </>
                                    )
                                }

                  {
                    promotionalCode && promotionalCode.length > 0 && (
                      <>
                        <div
                          className='mt-4'
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                          }}
                        >
                          <div
                            style={{
                              width: '50%',
                              justifyContent: 'start',
                            }}
                          >
                            <SpText color="#12BC5E" fontSize="18px" fontWeight="500" style={{ cursor: 'pointer' }} onClick={() => setShowPromoCode(!showPromoCode)} >Apply promocode</SpText>
                          </div>
                          <div
                            style={{
                              width: '50%',
                              justifyContent: 'start',
                            }}
                          >
                            &nbsp;
                          </div>
                        </div>
                        <>
                        {
                                  showPromoCode && promotionalCode.map((item, i) => (
                                    <>
                                    <div
                          className='mt-4'
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                          }}
                        >
                          <div
                            style={{
                              width: '50%',
                              justifyContent: 'start',
                            }}
                          >
                                        <Input
                                          placeholder={item.category || item.name}
                                          value={item.promotionalCode || ''}
                                          style={{
                                            width: '20%',
                                            height: '30px',
                                            border: '1px solid #3F8EF7',
                                            borderRadius: '6px',
                                            backgroundColor: '#ffffff',
                                            marginRight: '10px',
                                          }}
                                          onChange={(e) => {
                                            const list = [...promotionalCode];
                                            list[i].promotionalCode = e.currentTarget.value;
                                            setPromotionalCode(list);
                                          }}
                                        />
                                        <SpText color="#0E703A" fontSize="16px" fontWeight="600" style={{ cursor: 'pointer' }} onClick={() => getSplitUp()}>{discountAmount ? 'Applied' : 'Apply'}</SpText>
                                        <DeleteOutlined
                                          style={{ marginLeft: '10px', fontSize: '18px', cursor: 'pointer' }}
                                          onClick={() => removeGetSplitUp()}
                                        />
                                        
                                      </div>
                                      <div
                                        style={{
                                          width: '50%',
                                          justifyContent: 'start',
                                        }}
                                      >
                                        <p style={{ fontSize: '16px' }}>{currencyFormatter((AmountDivideByHundred(discountAmount)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}</p>
                                      </div>
                                    </div>
                                      <div
                                        className='mt-4'
                                        style={{
                                          justifyContent: 'center',
                                        }}
                                      >
                                        {
                                          promoError ? (
                                            <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                              Invalid Promo code
                                            </SpError>
                                          ) : (
                                            <></>
                                          )
                                        }
                                        {
                                          item.required ? (
                                            <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                              {simpleValidator.current.message('promotional code', item.promotionalCode, 'required')}
                                            </SpError>
                                          ) : (
                                            <></>
                                          )
                                        }
                                      </div>
                                    </>  
                                  ))
                                }
                        </>
                      </>
                    )
                  }


                                <hr />

                                <div
                                    className='mt-4'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'start',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '50%',
                                            justifyContent: 'start',
                                        }}
                                    >
                                        <p style={{ fontSize: '18px', fontWeight: '600' }}>Subtotal</p>
                                    </div>
                                    <div
                                        style={{
                                            width: '50%',
                                            justifyContent: 'start',
                                        }}
                                    >
                                        <p style={{ fontSize: '16px' }}>{selectedSeats.length !== 0 ? (totalPayable ? currencyFormatter((AmountDivideByHundred(totalPayable)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name) : getSubToatal(selectedSeats)) : '$ 0:00'}</p>
                                    </div>
                                </div>

                                {/* <div
                    className='mt-4'
                    style={{
                        display: 'flex',
                        justifyContent: 'start',
                    }}
                >
                    <div
                    style={{
                        width: '70%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '18px', fontWeight: '600' }}>Fees</p>
                    </div>
                    <div
                    style={{
                        width: '30%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '16px' }}>{currencyFormatter((eventDetails && eventDetails.serviceFeeRate), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}</p>
                    </div> 
                </div> */}

                                {/* <div
                    className='mt-4'
                    style={{
                        display: 'flex',
                        justifyContent: 'start',
                    }}
                >
                    <div
                    style={{
                        width: '70%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '18px', fontWeight: '600' }}>Tax</p>
                    </div>
                    <div
                    style={{
                        width: '30%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '16px' }}>{currencyFormatter((eventDetails && eventDetails.tax), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}</p>
                    </div> 
                </div> */}

                                {/* <hr /> */}

                                {/* <div
                    className='mt-4'
                    style={{
                        display: 'flex',
                        justifyContent: 'start',
                    }}
                >
                    <div
                    style={{
                        width: '70%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '18px', fontWeight: '600' }}>Total</p>
                    </div>
                    <div
                    style={{
                        width: '30%',
                        justifyContent: 'start',
                    }}
                    >
                        <p style={{ fontSize: '16px' }}>{currencyFormatter((eventDetails && (eventDetails.tax + eventDetails.serviceFeeRate + totalAmount)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}</p>
                    </div> 
                </div> */}
                            </div>

                            <div
                                className="mt-4"
                                style={{
                                    justifyContent: 'start',
                                }}
                            >
                                <Button type="primary"
                                    border="2px solid #40A9FF !important"
                                    color="#FFFFFF !important"
                                    paddingRight="1.5rem"
                                    paddingTop=".4rem"
                                    paddingBottom=".4rem"
                                    borderRadius="50px"
                                    paddingLeft="1.5rem"
                                    onClick={payTickets}
                                    width="250px"
                                    height="50px"
                                    style={{
                                        fontSize: "18px"
                                    }}
                                    disabled={!(selectedSeats && selectedSeats.length !== 0 && (subTotalGet(selectedSeats) > 0))}
                                >
                                    Checkout
                                </Button>

                            </div>
                        </div>
                        <Spinner isOpen={isShowSpinner} />
                    </div>
                ) : (
                    <div>
                        <div
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >

                            <div
                                className="mt-4 mb-4"
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <p style={{ fontSize: '24px', fontWeight: '700' }}>{eventDetails && eventDetails.title} @ {eventDetails && eventDetails.venueAddress}</p>
                            </div>
                            <div
                                className="mt-4 mb-4"
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                {
                                    eventDetails && eventDetails.eventEndTime ? (
                                        <p style={{ fontSize: '18px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)} - {getOperatingTime(eventDetails && eventDetails.eventEndTime)}, Time Left: {format(count)}</p>
                                    ) : (
                                        <p style={{ fontSize: '18px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)}, Time Left: {format(count)}</p>
                                    )
                                }
                            </div>

                        </div>

                        {/* <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            {
                                nonEventsSeats && nonEventsSeats.length !== 0 && (
                                    <>
                                        {
                                            nonEventsSeats.map((item, i) => (
                                                <div
                                                    key={i}
                                                    className='mr-4'
                                                    onClick={() => setDefaultCategorty(item)}
                                                    style={{
                                                        color: defaultCategory && defaultCategory.gid === item.gid ? '#3F8EF7' : '#000000',
                                                        borderBottom: defaultCategory && defaultCategory.gid === item.gid ? '2px solid #3F8EF7' : '',
                                                        fontSize: '18px',
                                                        paddingBottom: '10px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {item.category}
                                                </div>
                                            ))
                                        }
                                    </>
                                )
                            }
                        </div> */}
                        {/* <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <p style={{ fontSize: '16px', color: '#00000', fontWeight: '700'  }}>Ticket price includes Lunch, Light Snacks, coffee/Tea, and Dinner.</p>
                        </div> */}


                        {/* <div
                            className="mt-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <InputQuantity label={defaultCategory.category} setValue={setValue}
                                isPreview={false} isAdaptive={false}
                                control={control} errors={errors} description='(6 years and above)'
                                isRequired={defaultCategory.required} name='test'
                                comboHide={true}
                                selectedAccount={{}}
                                options={[]}
                                callCombo={callCombo}
                                id={defaultCategory.gid}
                                showComboError={false}
                                isComboBoxRequired={false}
                                selectedQnty={defaultCategory.selectedQnty}
                                availableQuantity={defaultCategory.availableQuantity}
                                amount={defaultCategory.price} currencyName={defaultCategory.currency && defaultCategory.currency.name}
                                maxQty={defaultCategory.quantityMaxLimit} minQty={defaultCategory.quantityMinLimit} />
                        </div> */}

                        {
                            nonEventsSeats && nonEventsSeats.length !== 0 && (
                                <>
                                    {
                                        nonEventsSeats.map((item, i) => (
                                            <div
                                                // className="mt-4"
                                                style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                }}
                                            >
                                                <InputQuantity label={item.category} setValue={setValue}
                                                    isPreview={false} isAdaptive={false}
                                                    control={control} errors={errors} description=''
                                                    isRequired={item.required} name={item.category}
                                                    comboHide={true}
                                                    selectedAccount={{}}
                                                    options={[]}
                                                    callCombo={callCombo}
                                                    id={item.gid}
                                                    showComboError={false}
                                                    isComboBoxRequired={false}
                                                    selectedQnty={item.selectedQnty}
                                                    availableQuantity={item.availableQuantity}
                                                    amount={item.price} currencyName={item.currency && item.currency.name}
                                                    maxQty={item.quantityMaxLimit} minQty={item.quantityMinLimit} />
                                            </div>
                                        ))
                                    }
                                </>
                            )
                        }

                        {
                            numAndAlpha && numAndAlpha.length !== 0 && (
                                <>
                                    {
                                        numAndAlpha.map((item, i) => (
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                }}
                                            >
                                                <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                                                    <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                                        <LabelText fontSize={normalTextFontSize(false, false)}
                                                            color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">{item.category || item.name}
                                                        </LabelText>
                                                    </div>
                                                    <div className={mobileView ? "" : "col-sm-7"} style={{ width: mobileView ? '60%' : '' }}>
                                                        <Input
                                                            placeholder={item.category || item.name}
                                                            value={item.alphaNum || ''}
                                                            style={{
                                                                width: '100%',
                                                                height: '30px',
                                                                border: '1px solid #3F8EF7',
                                                                borderRadius: '6px',
                                                                backgroundColor: '#ffffff',
                                                            }}
                                                            onChange={(e) => {
                                                                const list = [...numAndAlpha];
                                                                list[i].alphaNum = e.currentTarget.value;
                                                                setNumAndAlpha(list);
                                                            }}
                                                        // onChange={(e) => setAlphaNum(e.currentTarget.value)}
                                                        />
                                                        {
                                                            item.required ? (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message(item.category, item.alphaNum, 'required|alpha_num')}
                                                                </SpError>
                                                            ) : (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message(item.category, item.alphaNum, 'alpha_num')}
                                                                </SpError>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                        }
                        {
                            singleLineText && singleLineText.length !== 0 && (
                                <>
                                    {
                                        singleLineText.map((item, i) => (
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                }}
                                            >
                                                <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                                                    <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                                        <LabelText fontSize={normalTextFontSize(false, false)}
                                                            color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">{item.category || item.name}
                                                        </LabelText>
                                                    </div>
                                                    <div className={mobileView ? "" : "col-sm-7"} style={{ width: mobileView ? '60%' : '' }}>
                                                        <Input
                                                            placeholder={item.category || item.name}
                                                            value={item.value || ''}
                                                            style={{
                                                                width: '100%',
                                                                height: '30px',
                                                                border: '1px solid #3F8EF7',
                                                                borderRadius: '6px',
                                                                backgroundColor: '#ffffff',
                                                            }}
                                                            onChange={(e) => {
                                                                const list = [...singleLineText];
                                                                list[i].value = e.currentTarget.value;
                                                                setSingleLineText(list);
                                                            }}
                                                        // onChange={(e) => setAlphaNum(e.currentTarget.value)}
                                                        />
                                                        {
                                                            item?.required ? (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message(item?.category || item?.name, item.value, 'required|alpha_space')}
                                                                </SpError>
                                                            ) : (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message(item?.category || item?.name, item.value, 'alpha_space')}
                                                                </SpError>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                        }
                        {
                            inputEmail && inputEmail.length !== 0 && (
                                <>
                                    {
                                        inputEmail.map((item, i) => (
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                }}
                                            >
                                                <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                                                    <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                                        <LabelText fontSize={normalTextFontSize(false, false)}
                                                            color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">{item.category || item.name}
                                                        </LabelText>
                                                    </div>
                                                    <div className={mobileView ? "" : "col-sm-7"} style={{ width: mobileView ? '60%' : '' }}>
                                                        <Input
                                                            placeholder={item.category || item.name}
                                                            value={item.email || ''}
                                                            style={{
                                                                width: '100%',
                                                                height: '30px',
                                                                border: '1px solid #3F8EF7',
                                                                borderRadius: '6px',
                                                                backgroundColor: '#ffffff',
                                                            }}
                                                            onChange={(e) => {
                                                                const list = [...inputEmail];
                                                                list[i].email = e.currentTarget.value.toLowerCase();
                                                                setInputEmail(list);
                                                            }}
                                                        />
                                                        {
                                                            item.required ? (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('email', item.email, 'required|email')}
                                                                </SpError>
                                                            ) : (
                                                                <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('email', item.email, 'email')}
                                                                </SpError>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                        }
                        {/* <div
                            className="mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                                <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                    <LabelText fontSize={normalTextFontSize(false, false)}
                                        color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">Email
                                    </LabelText>
                                </div>
                                <div className={mobileView ? "" : "col-sm-7"} style={{ width: mobileView ? '60%' : '' }}>
                                    <Input
                                        placeholder="Email"
                                        style={{
                                            width: '100%',
                                            height: '30px',
                                            border: '1px solid #3F8EF7',
                                            borderRadius: '6px',
                                            backgroundColor: '#ffffff',
                                        }}
                                        value={email}
                                        onChange={(e) => setEmail(e.currentTarget.value.toLowerCase())}
                                    />
                                    <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                        {simpleValidator.current.message('email', email, 'required|email|checkLowerCase')}
                                    </SpError>
                                </div>
                            </div>
                        </div> */}

                        {
                            inputPhone && inputPhone.length !== 0 && (
                                <>
                                    {
                                        inputPhone.map((item, i) => (
                                            <>
                                                <div
                                                    className="mb-4"
                                                    style={{
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                                                        <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                                            <LabelText fontSize={normalTextFontSize(false, false)}
                                                                color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">Phone
                                                            </LabelText>
                                                        </div>
                                                        <div className="d-flex" style={{ width: mobileView ? '60%' : '' }}>
                                                            <div className="form-group" style={{ width: '75px', }}>
                                                                <SelectBox
                                                                    className="form-control"
                                                                    value={countryCode}
                                                                    onChange={onCountryCodeChange}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '30px',
                                                                        border: '1px solid #3F8EF7',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#ffffff',
                                                                    }}
                                                                >
                                                                    <option value={countryCode} hidden>{countryCode}</option>
                                                                    {
                                                                        COUNTRY_PHONE_CODE.map((item) => (
                                                                            <option key={item} value={item}>{item}</option>
                                                                        ))
                                                                    }
                                                                </SelectBox>
                                                                <SpError>
                                                                    {simpleValidator.current.message('country Code', countryCode, 'required')}
                                                                </SpError>
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '30px',
                                                                        border: '1px solid #3F8EF7',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#ffffff',
                                                                    }}
                                                                    // onChange={(e) => setPhone(e.currentTarget.value)}
                                                                    value={item.phone || ''}
                                                                    onChange={(e) => {
                                                                        const list = [...inputPhone];
                                                                        list[i].phone = e.currentTarget.value;
                                                                        setInputPhone(list);
                                                                    }}
                                                                />
                                                                {
                                                                    item.required ? (
                                                                        <SpError>
                                                                            {simpleValidator.current.message('phone', item.phone, `required|phoneNumValidation:${countryCode}${item.phone}`)}
                                                                        </SpError>
                                                                    ) : (
                                                                        <SpError>
                                                                            {simpleValidator.current.message('phone', item.phone, `phoneNumValidation:${countryCode}${item.phone}`)}
                                                                        </SpError>
                                                                    )
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}

                                </>
                            )
                        }

                {
                  promotionalCode && promotionalCode.length !== 0 && (
                    <>
                      {
                        promotionalCode.map((item, i) => (
                          <div
                            className="mb-4"
                            style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                              display: 'flex',
                            }}
                          >
                            <div className="form-group row mb-0 no-gutters align-items-center" style={{ width: mobileView ? '100%' : '30%' }}>
                              <div className={mobileView ? "" : "col-sm-5"} style={{ width: mobileView ? '40%' : '' }}>
                                <LabelText fontSize={normalTextFontSize(false, false)}
                                  color="#0000000" hidden={false} htmlFor="content" className="col-form-label font-weight-bolder m-0 text-break">{item.category || item.name}
                                </LabelText>
                              </div>
                              <div className={mobileView ? "" : "col-sm-7"} style={{ width: mobileView ? '60%' : '' }}>
                                <Input
                                  placeholder={item.category || item.name}
                                  value={item.promotionalCode || ''}
                                  style={{
                                    width: '80%',
                                    height: '30px',
                                    border: '1px solid #3F8EF7',
                                    borderRadius: '6px',
                                    backgroundColor: '#ffffff',
                                    marginRight: '10px',
                                  }}
                                  onChange={(e) => {
                                    const list = [...promotionalCode];
                                    list[i].promotionalCode = e.currentTarget.value;
                                    setPromotionalCode(list);
                                  }}
                                />
                                <SpText color="#0E703A" fontSize="16px" fontWeight="600" style={{ cursor: 'pointer' }} onClick={() => getSplitUp()}>Apply</SpText>
                                {
                                  promoError ? (
                                    <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                      Invalid Promo code
                                    </SpError>
                                  ) : (
                                    <></>
                                  )
                                }
                                {
                                  item.required ? (
                                    <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                      {simpleValidator.current.message('promotional code', item.promotionalCode, 'required')}
                                    </SpError>
                                  ) : (
                                    <></>
                                  )
                                }

                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </>
                  )
                }



                        {
                            isDataValid && (
                                <div
                                    className="mt-4 mb-4"
                                    style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'flex',
                                    }}
                                >
                                    <SpError>
                                        Please make at least one purchase.
                                    </SpError>
                                </div>
                            )
                        }
                        <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '16px',
                                }}
                            ><span style={{ fontWeight: '600' }}>Subtotal :</span> {currencyFormatter(AmountDivideByHundred(subTotal), defaultCategory.currency && defaultCategory.currency.name)} </div>
                        </div>
                        {
                          discountAmount ? (
                            <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '16px',
                                }}
                            ><span style={{ fontWeight: '600' }}>Discounted Amount :</span> {currencyFormatter(AmountDivideByHundred(discountAmount), defaultCategory.currency && defaultCategory.currency.name)} </div>
                        </div>
                          ) : (
                            <></>
                          )
                        }
                        
                        <hr style={{ width: '50%', marginLeft: '25%', }} />
                        <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '18px',
                                }}
                            ><span style={{ fontWeight: '600' }}>Total :</span> {currencyFormatter(AmountDivideByHundred(totalPayable), defaultCategory.currency && defaultCategory.currency.name)} </div>
                        </div>

                        <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <button class='border-0 mb-5' style={{ background: 'transparent' }}
                                disabled={eventDetails && eventDetails.status !== 'ACTIVE'}
                                type="submit" onClick={bookTickets}
                            ><img src={bookWithButton} alt="payButton" height='60' /></button>
                        </div>
                        <Spinner isOpen={isShowSpinner} />
                    </div>
                )
            }
        </div>
    )
};

export default Seats;
